module.exports = __webpack_public_path__ + "static/media/br_button.5d428b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/index/img/br_button.png
// module id = 1510
// module chunks = 0